import { render, staticRenderFns } from "./EqualGrid.vue?vue&type=template&id=6bec21ea&scoped=true&"
import script from "./EqualGrid.vue?vue&type=script&lang=js&"
export * from "./EqualGrid.vue?vue&type=script&lang=js&"
import style0 from "./EqualGrid.vue?vue&type=style&index=0&id=6bec21ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec21ea",
  null
  
)

export default component.exports